import React from "react";
import { logWarning, Status } from "@snapchat/web-log";
import { getLogger, logRequest } from "@snapchat/web-next-log";
import { ErrorWithStatus, fromAppPropsWithQueryLocale, fromError, updateResponseStatus, } from "@snapchat/web-proto-props";
import App from "next/app";
import { NotFound } from "../components/NotFound";
import { ContentUnavailable } from "../components/ContentUnavailable";
import { ensureRequestID } from "../lib/requests";
import "../styles/globals.css";
import { loadMessages } from "../i18n/messages";
import { POLICY_DIRECTIVES } from "../constants/csp";
import { setResponseHeaders } from "@snapchat/web-sc-next";
import { reportAccessibility } from "@snapchat/web-performance-metrics";
import Error from "./_error";
function CustomApp(appProps) {
    switch (appProps.status) {
        case Status.Ok:
            return <App {...appProps}/>;
        case Status.Gone:
        case Status.Unavailable:
            return (<ContentUnavailable disableUpsellQRCode={appProps.disableUpsellQRCode}/>);
        case Status.NotFound:
            return (<NotFound disableUpsellQRCode={appProps.disableUpsellQRCode}/>);
        default:
            return <Error />;
    }
}
/* istanbul ignore next -- Ignore this as it's backend code only */
CustomApp.getInitialProps = async (appContext) => {
    const { req, res } = appContext.ctx;
    const requestID = req ? ensureRequestID(req) : "";
    setResponseHeaders(requestID, req, res, POLICY_DIRECTIVES, true);
    const log = getLogger(requestID, req);
    logRequest(req, res, appContext, log);
    try {
        const appProps = await App.getInitialProps(appContext);
        return await fromAppPropsWithQueryLocale(req, appProps, loadMessages);
    }
    catch (err) {
        if (err instanceof ErrorWithStatus) {
            logWarning(err, log);
            updateResponseStatus(res, err);
            return fromError(err);
        }
        else {
            throw err;
        }
    }
};
void reportAccessibility(React);
export default CustomApp;
